import fetch from './index'
import util from '../util/util'
import {Loading} from 'element-ui';

export default {
    async rUpload(url, data){
        let loadingObj = Loading.service({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.6)'
        });
        let res = await fetch({
            url: url,
            method: 'post',
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            data
        })
        loadingObj.close();
        return res
    },
    async rCaptcha(){
      return await fetch({
          url: 'common/captcha',
          isGet: true,
          needAdmin: false,
        });
    },
    async rGet(url, data, loading){
        return this.rApi(url,data,'GET',loading)
    },
    async rPost(url, data, loading){
        return this.rApi(url,data,'POST',loading)
    },
    async rPut(url, data, loading){
        return this.rApi(url,data,'PUT',loading)
    },
    async rDelete(url, data, loading){
        return this.rApi(url,data,'DELETE',loading)
    },
    async rApi(url, data,method,loading = false, needAdmin = true) {
        if (!data) {
            data = {}
        }
        let loadingObj = null;
        if(loading){
            loadingObj = Loading.service({
                lock: true,
                text: '加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.6)'
            });
        }
        let res = null;
        try{
            res = await fetch({
                url: url,
                method: method,
                data,
                needAdmin: needAdmin
            })
        }catch(e){
            console.error('API调用失败:', e)
            if(loading){
                loadingObj.close();
            }
        }
        if(loading){
            loadingObj.close();
        }
        return res;
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/api/common.js